import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { LeadershipPage } from './pages/LeadershipPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-white font-sans text-brand-navy selection:bg-brand-red/20 selection:text-brand-red" data-id="element-2">
        <Header data-id="element-3" />
        <main data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
            <Route path="/services" element={<ServicesPage data-id="element-11" />} data-id="element-10" />
            <Route path="/leadership" element={<LeadershipPage data-id="element-13" />} data-id="element-12" />
            <Route path="/contact" element={<ContactPage data-id="element-15" />} data-id="element-14" />
            <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-17" />} data-id="element-16" />
          </Routes>
        </main>
        <Footer data-id="element-18" />
      </div>
    </BrowserRouter>;
}